module.exports = __webpack_public_path__ + "static/no-result-found-33f5132801fa12828023ab44992236d1.svg";